import React from 'react';
import './index.less';

const Banner = ({bannerBg, title, description}) => (
  <div className='new-banner'>
    <div className='banner-image'>
      <img src={bannerBg} alt='banner' />
    </div>
    <div className='banner-content'>
      <div className='title'>
        <span>{title}</span>
      </div>
      <div className='description'>
        {description}
      </div>
    </div>
  </div>
);

export default Banner;
